import { useCallback, useReducer } from 'react';
import highlightReducer from './highlightReducer';

export default function useHighlight(
	defaultHighlighted,
	options,
	onSelect,
	ref,
	focus
) {
	const [highlighted, dispatchHighlighted] = useReducer(
		highlightReducer,
		defaultHighlighted
	);
	const onKeyDown = useCallback(
		(e) => {
			const { key } = e;

			if (['ArrowDown', 'ArrowUp'].includes(key)) {
				e.preventDefault();
				dispatchHighlighted({ key, options });
			}
		},
		[options]
	);

	const onKeyPress = useCallback(
		(e) => {
			if ((e.key || '').toLowerCase() !== 'enter') {
				return;
			}

			e.preventDefault();

			// If dropdown is expanded
			if (focus) {
				const selected = options[highlighted];

				if (selected) {
					onSelect(selected.value);
				}
			} else {
				// Trigger click event
				ref.current.click();
			}
		},
		[focus, options, highlighted, onSelect, ref]
	);

	const onKeyUp = useCallback(
		(e) => {
			if ((e.key || '').toLowerCase() === 'escape') {
				e.preventDefault();
				ref.current.blur();
			}
		},
		[ref]
	);
	const resetHighlighted = useCallback(() => {
		dispatchHighlighted({ key: 'RESET' });
	}, []);

	return [highlighted, { onKeyPress, onKeyDown, onKeyUp }, resetHighlighted];
}
